import Cookies from 'js-cookie'
import Secret from '@/utils/secret'

// 用户信息（包含所属分公司）
let userInfo = null

export const TokenKey = 'Authorization'
export const CARGO_BRANCH_ID = 'CargoBranchId'
export const CARGO_DEPT_ID = 'CargoDeptId'

export function getCookiesToken() {
  return Cookies.get(TokenKey)
}

export function setCookiesToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeCookiesToken() {
  return Cookies.remove(TokenKey)
}

export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}

export function removeBranchId(userId, tenantId) {
  return window.localStorage.removeItem(`${CARGO_BRANCH_ID}_${tenantId}_${userId}`)
}

export function getBranchId(userId, tenantId) {
  return window.localStorage.getItem(`${CARGO_BRANCH_ID}_${tenantId}_${userId}`)
}

export function setBranchId(cargoBranchId, userId, tenantId) {
  return window.localStorage.setItem(`${CARGO_BRANCH_ID}_${tenantId}_${userId}`, cargoBranchId)
}

export function removeDeptId(userId, tenantId) {
  return window.localStorage.removeItem(`${CARGO_DEPT_ID}_${tenantId}_${userId}`)
}

export function getDeptId(userId, tenantId) {
  return window.localStorage.getItem(`${CARGO_DEPT_ID}_${tenantId}_${userId}`)
}

export function setDeptId(cargoDeptId, userId, tenantId) {
  return window.localStorage.setItem(`${CARGO_DEPT_ID}_${tenantId}_${userId}`, cargoDeptId)
}

export function setUserInfo(userInfoObj) {
  userInfo = userInfoObj
  // 这里实际只需要存sessionId，用于页面刷新时，获取sessionId重新查询用户信息
  const sessionUserInfo = { ...userInfoObj, currentUserOfficeList: [] }
  return window.sessionStorage.setItem('userInfoStr', Secret.Encrypt(JSON.stringify(sessionUserInfo)))
}

export function getUserInfo() {
  if (userInfo) {
    return userInfo
  }
  // 页面刷新时，会走这段逻辑，用于获取sessionId，查询用户信息
  const userInfoStr = window.sessionStorage.getItem('userInfoStr')
  return userInfoStr ? JSON.parse(Secret.Decrypt(window.sessionStorage.getItem('userInfoStr'))) : {}
}

export function setUserPermissions(permissions) {
  return window.sessionStorage.setItem('permissionsStr', Secret.Encrypt(JSON.stringify(permissions)))
}

export function getUserPermissions() {
  return JSON.parse(Secret.Decrypt(window.sessionStorage.getItem('permissionsStr')))
}
